export default "__VITE_ASSET__b9ec4b7f__"